import axiosInstance from "../../config/axiosInstance";
import { UserRoles, UserSectors } from "../../types/appData";
import { CreateUserPayload, UserArgs } from "../../types/users";

interface User {
  first_name: string;
  last_name: string;
  gpid: number;
  email: string;
  userRoles: UserRoles[];
  userSectors: UserSectors[];
}

const getUsers = async (params: UserArgs, signal: AbortSignal) => {
  const { data } = await axiosInstance.get<{ users: User[]; count: number }>(
    "/api/listUsers",
    { params, signal }
  );
  return data;
};

const createUser = async (user: CreateUserPayload) => {
  const payload = {
    gpid: user.gpid,
    firstName: user.firstName,
    lastName: user.lastName,
    email: user.email,
    roles: user.userRoles.map((e) => e.id),
    sectors: user.userSectors.map((e) => e.id),
  };
  const { data } = await axiosInstance.post("/api/createUser", payload);
  return data;
};
const updateUser = async (user: CreateUserPayload) => {
  const payload = {
    firstName: user.firstName,
    lastName: user.lastName,
    roles: user.userRoles.map((e) => e.id),
    sectors: user.userSectors.map((e) => e.id),
  };
  const { data } = await axiosInstance.put(
    `/api/updateUser/${user.gpid}`,
    payload
  );
  return data;
};
const usersService = {
  getUsers,
  createUser,
  updateUser,
};
export default usersService;
